import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on mount
    initMetaPixel('1475521464237069');
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}